import { useCallback, useState } from 'react';
import type { ReactElement } from 'react';
import { UploadModal } from './upload-modal';

export const UploadVideo = ({ clientId, assetId, togglePlayer }: { clientId: string; assetId: number; togglePlayer: () => void }): ReactElement => {
  const [show, setShow] = useState(false);

  const close = useCallback(() => {
    setShow(false);
  }, []);

  return (
    <>
      <button className="btn btn-outline-secondary" style={{ direction: 'ltr' }}
      onClick={(): void => {
        setShow(true);
      }} type="button">
        <i className="mr-8px">
          <svg className="" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.46128 1.07827C9.34286 0.948767 9.17552 0.875 9.00002 0.875C8.82452 0.875 8.65719 0.948767 8.53877 1.07827L5.20542 4.7241C4.97251 4.97885 4.99021 5.37418 5.24496 5.6071C5.49972 5.84002 5.89504 5.82232 6.12796 5.56757L8.37502 3.10983V12.3333C8.37502 12.6785 8.65486 12.9583 9.00002 12.9583C9.34519 12.9583 9.62502 12.6785 9.62502 12.3333V3.10983L11.8721 5.56757C12.105 5.82232 12.5004 5.84002 12.7551 5.6071C13.0099 5.37418 13.0275 4.97885 12.7946 4.7241L9.46128 1.07827Z" fill="currentColor"/>
            <path d="M2.125 11.5C2.125 11.1548 1.84518 10.875 1.5 10.875C1.15483 10.875 0.875 11.1548 0.875 11.5V11.5458C0.874984 12.6854 0.874967 13.604 0.9721 14.3265C1.07295 15.0766 1.28869 15.7081 1.79029 16.2097C2.29189 16.7113 2.92345 16.9271 3.67354 17.0279C4.39602 17.125 5.31462 17.125 6.45428 17.125H11.5458C12.6854 17.125 13.604 17.125 14.3265 17.0279C15.0766 16.9271 15.7081 16.7113 16.2097 16.2097C16.7113 15.7081 16.9271 15.0766 17.0279 14.3265C17.125 13.604 17.125 12.6854 17.125 11.5458V11.5C17.125 11.1548 16.8452 10.875 16.5 10.875C16.1548 10.875 15.875 11.1548 15.875 11.5C15.875 12.6962 15.8737 13.5304 15.7891 14.1599C15.7068 14.7714 15.5565 15.0952 15.3258 15.3258C15.0952 15.5565 14.7714 15.7068 14.1599 15.7891C13.5304 15.8737 12.6962 15.875 11.5 15.875H6.5C5.30383 15.875 4.46956 15.8737 3.8401 15.7891C3.22863 15.7068 2.90481 15.5565 2.67418 15.3258C2.44354 15.0952 2.29317 14.7714 2.21096 14.1599C2.12633 13.5304 2.125 12.6962 2.125 11.5Z" fill="currentColor"/>
          </svg>
        </i>
        Replace Asset
      </button>
      <UploadModal
      clientId={clientId}
      assetId={assetId}
      onClose={close}
      togglePlayer={togglePlayer}
      show={show} />
    </>
  );
};
